// extracted by mini-css-extract-plugin
module.exports = {"promotionButton":"_d6068a9","promotionCloseButton":"_780d5d7","promotionOpenButton":"_ec7ac4f","freeBetIcon":"_b128ebe","promotionRemoveButton":"_55e9da3"};